import { AnnotationComponentProps } from "@routes/Article/components/StoryElements/Annotation/utils/types";

export default function AnnotationComponentStrikethrough({
  children,
}: AnnotationComponentProps): React.ReactElement {
  return <s>{children}</s>;
}
